/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { TrustDetailsViewModel } from './TrustDetailsViewModel';
import {
    TrustDetailsViewModelFromJSON,
    TrustDetailsViewModelFromJSONTyped,
    TrustDetailsViewModelToJSON,
} from './TrustDetailsViewModel';

/**
 * 
 * @export
 * @interface ResultOfTrustDetailsViewModel
 */
export interface ResultOfTrustDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfTrustDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTrustDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfTrustDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTrustDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTrustDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfTrustDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfTrustDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {TrustDetailsViewModel}
     * @memberof ResultOfTrustDetailsViewModel
     */
    data?: TrustDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfTrustDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfTrustDetailsViewModel interface.
 */
export function instanceOfResultOfTrustDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfTrustDetailsViewModelFromJSON(json: any): ResultOfTrustDetailsViewModel {
    return ResultOfTrustDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfTrustDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfTrustDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : TrustDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfTrustDetailsViewModelToJSON(value?: ResultOfTrustDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': TrustDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

